"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _userSettings = require("ComposeUI/redux/actions/userSettings");

var _constants = require("ComposeUI/lib/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var _welcome2x = _interopRequireDefault(require("bender-url!ComposeUI/img/welcome@2x.png"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

function langKey(key) {
  return "ComposeUI.welcomeModal." + key;
}

var OnboardingModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(OnboardingModal, _PureComponent);

  function OnboardingModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, OnboardingModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(OnboardingModal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleDismiss = function () {
      var _this$props = _this.props,
          dismissModal = _this$props.dismissModal,
          userId = _this$props.userId,
          userSettings = _this$props.userSettings;
      (0, _userSettings.markSeenOnboarding)(userId, userSettings);
      dismissModal();
    };

    return _this;
  }

  (0, _createClass2.default)(OnboardingModal, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var open = nextProps.open,
          userSettings = nextProps.userSettings;
      var seenOnboarding = userSettings.seenOnboarding,
          status = userSettings.status;
      var lastStatus = this.props.userSettings.status;

      if (!open && lastStatus !== _constants.RequestStatus.SUCCEEDED && status === _constants.RequestStatus.SUCCEEDED && !seenOnboarding) {
        this.props.openOnboardingModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var modalOpen = this.props.modalOpen;

      if (modalOpen !== _constants.ModalNames.ONBOARDING) {
        return null;
      }

      return _react.default.createElement(_UIModal.default, {
        className: "welcome-modal",
        size: "short",
        use: "info",
        width: 540
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('header')
      }))), _react.default.createElement(_UIDialogBody.default, {
        className: "welcome-modal-body"
      }, _react.default.createElement(_UIImage.default, {
        className: "m-bottom-5",
        src: _welcome2x.default,
        style: {
          width: 201,
          height: 212,
          margin: '0 auto'
        }
      }), _react.default.createElement(_FormattedMessage.default, {
        message: langKey('body')
      })), _react.default.createElement(_UIDialogFooter.default, {
        align: "center"
      }, _react.default.createElement(_UIButton.default, {
        onClick: this.handleDismiss,
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('button')
      }))));
    }
  }]);
  return OnboardingModal;
}(_react.PureComponent);

OnboardingModal.propTypes = {
  dismissModal: _propTypes.default.func.isRequired,
  modalOpen: _propTypes.default.string,
  open: _propTypes.default.bool,
  openOnboardingModal: _propTypes.default.func.isRequired,
  userId: _propTypes.default.number,
  userSettings: _propTypes.default.instanceOf(_UserSettings.default).isRequired
};
var _default = OnboardingModal;
exports.default = _default;
module.exports = exports.default;